import React from "react";
import Api from "../api/client";

const REDUCER_TYPES = {
  INIT: "INIT",
  LOAD_CARS: "LOAD_CARS",
  APPLY_FILTERS: "APPLY_FILTERS",
};

function getFilterValue(filters, key) {
  return filters?.find((filter) => filter.key === key)?.value || null;
}

const ONCHANGEFILTERKEYS = [
  "brand",
  "year",
  "type",
  "transmission",
  "model",
  "city",
  "state",
  "lte-year",
  "gte-year",
  "lte-price",
  "gte-price",
];

const SORTKEYS = ["sort_by", "order"];

function reduceSortQueries(sorted, currentQuery) {
  if (SORTKEYS.includes(currentQuery.key)) {
    return {
      ...sorted,
      [currentQuery.key]: currentQuery.value,
    };
  }
  return sorted;
}

function generateQueryString({
  currentPage,
  filters,
  sort,
  business,
  onlyRecommended,
}) {
  return {
    page: currentPage,
    brand: getFilterValue(filters, "brand"),
    model: getFilterValue(filters, "model"),
    year: getFilterValue(filters, "year"),
    type: getFilterValue(filters, "type"),
    city: getFilterValue(filters, "city"),
    "lte-year": getFilterValue(filters, "lte-year"),
    "gte-year": getFilterValue(filters, "gte-year"),
    "lte-price": getFilterValue(filters, "lte-price"),
    "gte-price": getFilterValue(filters, "gte-price"),
    state: getFilterValue(filters, "state"),
    transmission: getFilterValue(filters, "transmission"),
    sort_by: sort?.sort_by,
    order: sort?.order,
    business: business || null,
    onlyRecommended,
  };
}

function carListReducer(state, { type, payload }) {
  switch (type) {
    case REDUCER_TYPES.LOAD_CARS:
      return {
        ...state,
        cars: payload.cars,
        pages: payload.pagination.pages,
        isLoading: false,
      };
    case REDUCER_TYPES.APPLY_FILTERS:
      return {
        ...state,
        isLoading: true,
        currentPage: Number(payload.page),
        filters: payload.filters,
        sort: payload.sort,
      };

    case REDUCER_TYPES.default:
      return state;
  }
}

export default function useCarList({
  initialPage = 0,
  initialPages = 0,
  initialCars = [],
  initialFilters = null,
  initialSort = null,
  businessId,
  onlyRecommended = false,
}) {
  const firstLoad = React.useRef(true);
  const [state, dispatch] = React.useReducer(carListReducer, {
    cars: initialCars,
    isLoading: false,
    business: businessId,
    pages: initialPages,
    currentPage: initialPage,
    filters: initialFilters,
    sort: initialSort,
  });

  React.useEffect(() => {
    if (!firstLoad.current) {
      const queryString = generateQueryString({
        currentPage: state.currentPage,
        filters: state.filters,
        sort: state.sort,
        business: state.business,
        onlyRecommended,
      });
      console.log(queryString);
      Api.list({ queries: queryString })
        .then((r) => r.json())
        .then((data) => {
          dispatch({
            type: REDUCER_TYPES.LOAD_CARS,
            payload: {
              cars: data.cars,
              pagination: data.pagination,
            },
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      firstLoad.current = false;
    }
  }, [
    state.currentPage,
    state.business,
    dispatch,
    state.filters,
    state.sort,
    onlyRecommended,
  ]);

  const onChangeQueries = React.useCallback(
    (queries) => {
      const filters = queries.filter((query) =>
        ONCHANGEFILTERKEYS.includes(query.key)
      );
      const sorts = queries.reduce(reduceSortQueries, {});

      dispatch({
        type: REDUCER_TYPES.APPLY_FILTERS,
        payload: {
          page: queries.find((q) => q.key === "page")?.value || 1,
          filters: filters,
          sort: sorts,
        },
      });
    },
    [dispatch]
  );

  return { state, onChangeQueries };
}
